import { gql } from "@urql/core";

import { query } from "@/services/lukita";

export default function projectsQuery({ accountId } = {}) {
  return query(
    gql`
      query ProjectsQuery($accountId: ID!) {
        projects(accountId: $accountId) {
          __typename
          id
          slug
          name
          status
          createdAt
          statementsMetadata {
            numberOfPages
          }
        }
        metadata: projectsMetadata(accountId: $accountId) {
          count
        }
      }
    `,
    { accountId },
    { additionalTypenames: ["ProjectRecord"] },
  );
}
